module.exports = __webpack_public_path__ + "img/icon-arrow-circle-down.7d2d0841.svg";